module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [(_vm.clinicReady) ? _c('div', {
    staticClass: "component-wrapper"
  }, [_c(_vm.$route.params.page, {
    tag: "component",
    attrs: {
      "clinic": _vm.clinic
    },
    on: {
      "update:clinic": function($event) {
        _vm.clinic = $event
      },
      "finishStep": _vm.finishStep,
      "cancelChange": _vm.cancelChange
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm",
    slot: "loader"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('sweet-modal', {
    ref: "modal",
    attrs: {
      "icon": "success"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4edac0d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clinic/steps/SingleForm.vue
// module id = 1006
// module chunks = 1